import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from 'react-native-paper';

interface JobSectionProps {
  title: string;
  count: number;
  emptyMessage: string;
  children?: React.ReactNode;
}

const JobSection: React.FC<JobSectionProps> = ({
  title,
  count,
  emptyMessage,
  children,
}) => {
  const theme = useTheme();
  const isEmpty = count === 0 || !children;

  return (
    <View style={styles.section}>
      <View style={styles.header}>
        <Text style={[styles.title, { color: theme.colors.onSurfaceVariant }]}>
          {title}
        </Text>
        <View style={[styles.countPill, { backgroundColor: theme.colors.surfaceVariant }]}>
          <Text style={[styles.countText, { color: theme.colors.onSurfaceVariant }]}>
            {count}
          </Text>
        </View>
      </View>
      {isEmpty ? (
        <Text style={[styles.empty, { color: theme.colors.onSurfaceVariant }]}>
          {emptyMessage}
        </Text>
      ) : (
        <View style={styles.body}>{children}</View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
    marginTop: 12,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 6,
  },
  title: {
    fontFamily: 'Inter-Medium',
    fontSize: 11,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
  },
  countPill: {
    paddingHorizontal: 8,
    paddingVertical: 1,
    borderRadius: 9999,
  },
  countText: {
    fontFamily: 'Inter-Medium',
    fontSize: 11,
  },
  empty: {
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    fontStyle: 'italic',
    paddingVertical: 4,
  },
  body: {
    gap: 10,
    marginTop: 4,
  },
});

export default JobSection;
